module.exports = __webpack_public_path__ + "static/RootSans-8SemiBoldItalic-fe8a4094d4aa2c466c370309716f4e21.woff";